import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PPAuthService } from '../../../core/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-set-new-password-form',
  templateUrl: './set-new-password-form.component.html',
  styleUrls: ['./set-new-password-form.component.scss'],
})
export class SetNewPasswordFormComponent implements OnInit {

  
  form: FormGroup;
  matchingPasswords: FormGroup;
  password: FormControl;
  confirmPassword: FormControl;

  passwordFirstBlur = false;
  passwordFocus = false;
  confirmPasswordFirstBlur = false;
  confirmPasswordFocus = false;
  tryToSubmit = false;
  loading = false;

  constructor( public translateService:TranslateService, private authService: PPAuthService, private route: ActivatedRoute, public toastController: ToastController, private router: Router ) { }

  onFormSubmit() {

    this.tryToSubmit = true;

    if ( !this.form.valid ) {
      return false;
    }

    console.log(this.route);

    if ( !this.route.snapshot.queryParams.email || !this.route.snapshot.queryParams.token || !this.matchingPasswords.controls['password'].value ) {
      this.router.navigate( ['/auth', 'pozabljeno-geslo'] ); //redirect to forgotten password
      return false;
    }

    this.loading = true;

    this.authService.resetPassword$( 
      this.matchingPasswords.controls['password'].value, 
      this.route.snapshot.queryParams.email,
      this.route.snapshot.queryParams.token
    ).subscribe(

      result => {
        this.loading = false;
        this.presentToast( 'Novo geslo je nastavljeno. Prijavi se z novim geslom.' ); 
        this.router.navigate( ['/auth', 'prijava'] ); //redirect to login
      },

      error   =>  {
        this.loading = false;
        this.presentToast( 'Napaka, zahtevek ste že uporabili ali je potekel. Pošljite novo povezavo.')
        this.router.navigate( ['/auth', 'pozabljeno-geslo'] ); //redirect to forgotten password
      }

    );

  }

  async presentToast( text ) {
    const toast = await this.toastController.create({
      message: text,
      duration: 10000,
      color: 'primary'
    });
    toast.present();
  }

  matchValidator(group: FormGroup) {

    if ( group.controls['password'].value == group.controls['confirmPassword'].value ) {
      return null;
    }

    return {
      mismatch: true
    };

  }

  ngOnInit() {


    this.password = new FormControl( '', [
      Validators.required,
      Validators.minLength(6)
    ]);

    this.confirmPassword = new FormControl( '', [
      Validators.required
    ]);

    this.matchingPasswords = new FormGroup({
      'password': this.password,
      'confirmPassword': this.confirmPassword
    }, [ this.matchValidator ] )

    this.form = new FormGroup({
      matchingPasswords: this.matchingPasswords
    });


  }

}
